import struttureAsstRaw from '../../public/data/struttureAsst.json'
import type { AmbitoId } from './ambitiStats'

type RawStrutturaSanitaria = {
  'Tipo struttura Sanitaria': string
  'Denominazione Struttura Sanitaria': string
  'Indirizzo Struttura Sanitaria': string
  'Comune Struttura': string
  'Distretto di appartenenza': string
  CAP: number | string
  Latitudine: number
  Longitudine: number
  url?: string
  telefono?: string
  email?: string
  orari?: string
  altre_info?: string
  ambito_web?: string
  strutture_web?: string[]
  bsd_name?: string
  bsd_denominazione?: string
}

export interface StrutturaSanitaria {
  id: string
  tipo: string
  nome: string
  indirizzo: string
  comune: string
  distretto: string
  cap: string
  latitudine: number
  longitudine: number
  ambitoId: AmbitoId
  url: string
  telefono: string
  email: string
  orari: string
  altreInfo: string
  ambitoWeb: string
  struttureWeb: string[]
  bsdName: string
  bsdDenominazione: string
}

function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

export function strutturaAsstSlug(nome: string): string {
  return slugify(nome)
}

function resolveAmbitoId(distretto: string): AmbitoId {
  const normalized = distretto.trim().toLowerCase()
  if (normalized.includes('carate')) return 'carate'
  if (normalized.includes('desio')) return 'desio'
  if (normalized.includes('monza')) return 'monza'
  if (normalized.includes('seregno')) return 'seregno'
  return 'vimercate'
}

export const STRUTTURE_SANITARIE: StrutturaSanitaria[] = (struttureAsstRaw as RawStrutturaSanitaria[]).map((entry, index) => ({
  id: `${slugify(entry['Denominazione Struttura Sanitaria'])}-${index}`,
  tipo: entry['Tipo struttura Sanitaria'],
  nome: entry['Denominazione Struttura Sanitaria'],
  indirizzo: entry['Indirizzo Struttura Sanitaria'],
  comune: entry['Comune Struttura'],
  distretto: entry['Distretto di appartenenza'],
  cap: String(entry.CAP ?? ''),
  latitudine: Number(entry.Latitudine),
  longitudine: Number(entry.Longitudine),
  ambitoId: resolveAmbitoId(entry['Distretto di appartenenza']),
  url: entry.url ?? '',
  telefono: entry.telefono ?? '',
  email: entry.email ?? '',
  orari: entry.orari ?? '',
  altreInfo: entry.altre_info ?? '',
  ambitoWeb: entry.ambito_web ?? '',
  struttureWeb: Array.isArray(entry.strutture_web) ? entry.strutture_web.filter(Boolean) : [],
  bsdName: entry.bsd_name ?? '',
  bsdDenominazione: entry.bsd_denominazione ?? '',
}))

export function findStrutturaAsstBySlug(slug: string): StrutturaSanitaria | undefined {
  return STRUTTURE_SANITARIE.find(struttura => struttura.id === slug || strutturaAsstSlug(struttura.nome) === slug)
}
